<template>
    <section v-if="set" class="set-details-wrapper">
        <img class="artist-avatar" :src="set.avatar" alt="artist-avatar" />
        <div class="set-details">
            <p class="artist-name">{{ set.artistName }}</p>
            <div v-if="mode === 'details'" class="details-info">
                <div class="set-length">
                    <span class="label">Set Length</span>
                    <span class="value"
                        >{{ Math.round(parseFloat(set.duration * 60).toFixed(0)) }}min</span
                    >
                </div>
                <div class="set-start">
                    <span class="label">Start at</span>
                    <span class="value">{{ set.start }}</span>
                </div>
            </div>
            <div v-else class="payout-info">
                <div class="payout-total">
                    <span class="label">Payout</span>
                    <span class="value">${{ set.venuePays }}</span>
                </div>
                <div class="payout-breakdown">
                    <span class="label">Hedlyner Fees:</span>
                    <span class="value">${{ set.venueCommission }},&nbsp;</span>
                    <span class="label">Artist Fee:</span>
                    <span class="value">${{ set.venueHedlynerFee }}</span>
                </div>
            </div>
        </div>
    </section>
</template>
<script>
    export default {
        name: 'SetDetails',
        props: {
            set: {
                required: false,
                type: Object,
                default: null
            },
            mode: {
                required: false,
                type: String,
                default: null
            }
        }
    }
</script>
<style lang="scss" scoped>
    @import '../../../../../../sass/_variables.scss';
    p {
        margin-bottom: 0px;
    }
    .set-details-wrapper {
        width: 100%;
        max-width: 553px;
        height: 64px;
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        gap: 16px;

        @media screen and (max-width: 600px) {
            height: 84px;
        }
        .artist-avatar {
            width: 64px;
            height: 64px;
            border-radius: 8px;
            object-fit: cover;
        }
        .set-details {
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            justify-content: center;
            gap: 4px;

            .artist-name {
                overflow: hidden;
                color: #dedede;
                text-overflow: ellipsis;
                font-family: 'Instrument Sans';
                font-size: 18px;
                font-style: normal;
                font-weight: 650;
                line-height: 120%;
            }
            .details-info,
            .payout-info {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                gap: 16px;

                .set-length,
                .set-start,
                .payout-total,
                .payout-breakdown {
                    display: flex;
                    flex-direction: row;
                    justify-content: flex-start;
                    align-items: center;
                    gap: 4px;

                    .label {
                        color: #646464;
                        font-family: 'Instrument Sans';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                    }
                    .value {
                        color: #acacac;
                        font-family: 'Instrument Sans';
                        font-size: 14px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: 130%;
                        letter-spacing: 0.14px;
                    }
                }
            }
            .payout-info {
                @media screen and (max-width: 600px) {
                    flex-direction: column;
                    align-items: flex-start;
                    gap: 0px;
                }
            }
        }
    }
</style>
